import { CeProductSortingEvent } from '~/features/tracking/model';
import { pushToDataLayer } from '~/features/tracking/utils/pushToDataLayer';

export const useProductSortingTracking = () => {
	return (sorting: string) => {
		pushToDataLayer<CeProductSortingEvent>({
			event: 'product_sorting',
			sortingSelected: sorting.toLowerCase(),
		});
	};
};
